import { useState } from 'react';

export default function useMenu() {
  return useState(false);
}
